import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const leadStatusApi = {
  getLeadStatuses: async ({ page = 1, perPage = 10, search = '', includeTrashed = false, paginate = true } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.LEAD_STATUSES}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false', paginate },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching lead statuses:', error);
      throw error;
    }
  },

  getLeadStatusByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.LEAD_STATUSES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching lead status ${identifier}:`, error);
      throw error;
    }
  },

  createLeadStatus: async (leadStatusData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.LEAD_STATUSES}`, leadStatusData);
      return response.data;
    } catch (error) {
      console.error('Error creating lead status:', error);
      throw error;
    }
  },

  updateLeadStatus: async (identifier, leadStatusData) => {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.LEAD_STATUSES}/${identifier}`, leadStatusData);
      return response.data;
    } catch (error) {
      console.error(`Error updating lead status ${identifier}:`, error);
      throw error;
    }
  },

  trashLeadStatus: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.LEAD_STATUSES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing lead status ${identifier}:`, error);
      throw error;
    }
  },

  restoreLeadStatus: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.LEAD_STATUSES}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring lead status ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteLeadStatus: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.LEAD_STATUSES}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting lead status ${identifier}:`, error);
      throw error;
    }
  },
};

export default leadStatusApi;